export const TOS = "https://y-e.co/terms/MerchantAgreement.pdf";
export const INCORPORATED = "https://www.yoello.com/sign-up-instructions-step-2-incorporated-companies";
export const SOLO = "https://www.yoello.com/sign-up-instructions-step-2-sole-traders";
export const SIGN_UP = "https://www.yoello.com/sign-up-instructions-step-1";
